import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useTheme } from '../../hooks/useTheme';

const MoodTrendChart = ({ moodData }) => {
  const { theme } = useTheme();
  
  const recentMoods = moodData.slice(-7).map(m => ({
    date: new Date(m.date).toLocaleDateString('en', { weekday: 'short' }),
    mood: m.mood
  }));

  return (
    <div className={`p-6 rounded-xl ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
      <h3 className="font-semibold mb-4">Mood Trend (Last 7 Days)</h3>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={recentMoods}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis domain={[0, 5]} ticks={[1, 2, 3, 4, 5]} />
          <Tooltip />
          <Line 
            type="monotone" 
            dataKey="mood" 
            stroke="#3B82F6" 
            strokeWidth={2}
            dot={{ fill: '#3B82F6' }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MoodTrendChart;